module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "offline-button",
    class: _vm.$style.root
  }, [_c('icon', {
    staticClass: "connection-icon wifi-icon",
    class: {
      online: _vm.isOnline, offline: !_vm.isOnline
    },
    attrs: {
      "name": "wifi",
      "scale": "1"
    }
  }), _c('icon', {
    staticClass: "connection-icon ban-icon",
    class: {
      online: _vm.isOnline, offline: !_vm.isOnline
    },
    attrs: {
      "name": "ban",
      "scale": "1"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9bbe83a0"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/offline-button/OfflineButton.vue
// module id = 955
// module chunks = 1